import { render, staticRenderFns } from "./DialogAssignTask.vue?vue&type=template&id=206964ac&scoped=true"
import script from "./DialogAssignTask.vue?vue&type=script&lang=js"
export * from "./DialogAssignTask.vue?vue&type=script&lang=js"
import style0 from "./DialogAssignTask.vue?vue&type=style&index=0&id=206964ac&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "206964ac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Mobaxe\\Nevo.SimAdmin.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('206964ac')) {
      api.createRecord('206964ac', component.options)
    } else {
      api.reload('206964ac', component.options)
    }
    module.hot.accept("./DialogAssignTask.vue?vue&type=template&id=206964ac&scoped=true", function () {
      api.rerender('206964ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DialogAssignTask.vue"
export default component.exports